export default {
  tableTitle: {
    id: 'bo_sellers_customer_care_open_tasks_table_aria_label',
    defaultMessage: 'Open tasks table',
  },
  statusHeader: {
    id: 'bo_sellers_customer_care_open_tasks_table_head_status',
    defaultMessage: 'Status',
  },
  taskHeader: {
    id: 'bo_sellers_customer_care_open_tasks_table_head_task',
    defaultMessage: 'Task',
  },
  issueTypeHeader: {
    id: 'bo_sellers_customer_care_open_tasks_table_head_issue_type',
    defaultMessage: 'Issue type',
  },
  orderIdHeader: {
    id: 'bo_sellers_customer_care_open_tasks_table_head_order_id',
    defaultMessage: 'Order #',
  },
  customerHeader: {
    id: 'bo_sellers_customer_care_open_tasks_table_head_customer',
    defaultMessage: 'Customer',
  },
  statusTooltip: {
    id: 'bo_sellers_customer_care_open_tasks_table_status_tooltip',
    defaultMessage: 'Status deadlines are in business days.',
  },
  uploadReceiptHeader: {
    id: 'bo_seller.customer_care.request.open_tasks.upload_receipt_table_column',
    defaultMessage: 'Upload receipt',
  },
  actionsHeader: {
    id: 'bo_seller.customer_care.request.open_tasks.actions_column_header',
    defaultMessage: 'Actions',
  },
}
